import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  FormControl,
  Heading,
  Radio,
  RadioGroup,
  Spacer,
  Stack,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { useState } from "react";
import { useMutation } from "react-query";
import { Link, useNavigate } from "react-router-dom";
import { comicImportSources } from "../../../core/constants";
import http from "../../../core/http";
import { adminImportComic } from "../../../services/adminApi";
import { Card } from "../../auth/components/Login/Card";
import ComicForm from "../components/ComicForm";
import ComicImportForm from "../components/ComicImportForm";

function ComicNew() {
  const navigate = useNavigate();
  const toast = useToast();
  const [creationMode, setCreationMode] = useState("1");
  const { isLoading, mutateAsync } = useMutation(({ source, url }) => {
    return adminImportComic(source, url);
  });

  // Handle form submit
  async function handleSubmit(values) {
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("description", values.description);
    formData.append("franchise", values.franchise);
    formData.append("thumbnail", values.thumbnail);

    try {
      await http.post("/v1/admin/comics", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      toast({
        title: "Comic created.",
        description: "The comic has been created in the database.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      navigate("/comics/all");

      // handle success
    } catch (error) {
      console.error(error);
      // handle error
      toast({
        title: "Error occured",
        description: JSON.stringify(error),
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    }
  }

  async function handleImportSubmit(source, url) {
    mutateAsync({ source, url })
      .then(({ data }) => {
        toast({
          title: "Comic imported.",
          description: `${data.title} has been imported in the database.`,
          status: "success",
          duration: 5000,
          isClosable: true,
        });

        navigate("/comics/all");
      })
      .catch((error) => {
        console.error(error);
        toast({
          title: "Comic import failed",
          description:
            error.response?.data?.message ||
            "The comic could not be imported from that URL.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
  }

  return (
    <Box
      bg={useColorModeValue("gray.50", "inherit")}
      minH="100vh"
      py="12"
      px={{ base: "4", lg: "8" }}
    >
      <Box maxW="xl" mx="auto">
        <Breadcrumb mb="3">
          <BreadcrumbItem>
            <BreadcrumbLink as={Link} to="/comics/all">
              Comics
            </BreadcrumbLink>
          </BreadcrumbItem>

          <BreadcrumbItem isCurrentPage>
            <BreadcrumbLink>New comic</BreadcrumbLink>
          </BreadcrumbItem>
        </Breadcrumb>

        <Card>
          <Heading as="h2" mb="6">
            New comic
          </Heading>

          <FormControl>
            <RadioGroup
              onChange={(value) => setCreationMode(value)}
              value={creationMode}
            >
              <Stack direction="column">
                {Object.keys(comicImportSources).map((key) => (
                  <Radio key={key} value={key}>
                    Import from a {comicImportSources[key].sourceLabel} URL
                  </Radio>
                ))}
                <Radio key={0} value="0">
                  Create manually
                </Radio>
              </Stack>
            </RadioGroup>
          </FormControl>

          <Spacer py="3" />

          {creationMode > 0 && (
            <ComicImportForm
              source={comicImportSources[creationMode]}
              handleSubmit={handleImportSubmit}
              isLoading={isLoading}
            />
          )}

          {creationMode === "0" && <ComicForm handleSubmit={handleSubmit} />}
        </Card>
      </Box>
    </Box>
  );
}

export default ComicNew;
